<template>
  <div
    id="anm22_template_anm22it_2014_headBar"
    :class="[
      'anm22_template_anm22it_2014_headBar',
      'display-flex',
      'f-align-center',
      isOffline ? 'inverted' : '',
    ]"
    :style="!userLogged ? 'justify-content:flex-start;' : ''"
  >
    <!-- Controllo se nello stato è settato un link holoback, altrimenti renderizzo l'icona per aprire il menu -->
    <!-- Utilizzare lo stato dell'applicazione per gestire il tasto back -->
    <div
      v-if="$route.path !== '/login'"
      class="anm22_template_anm22it_2014_headBar_logo"
      id="anm22_template_anm22it_2014_headBar_holo"
    >
      <img
        v-if="backHref"
        :src="$anm22.icons.getWorldIcon('back')"
        class="anm22_template_anm22it_2014_headBar_holo_img_square"
        @click="$router.push(backHref).catch((e) => {})"
      />
      <img
        v-else
        :src="$anm22.icons.getWorldIcon('menu')"
        style="cursor: pointer"
        class="anm22_template_anm22it_2014_headBar_holo_img_square"
        @click="$emit('openWorldMenu')"
        wg-id="wg-world-headbar-menu-btn"
      />
    </div>
    <!-- Immagine App -->
    <div
      class="com-anm22-headbar-app-logo"
      style="cursor: pointer"
      @click="logoClick"
    >
      <img
        :src="
          theme !== 'anm22' || $route.path !== '/login'
            ? $store.getters['config/HBTheme'].appImg
            : $anm22.icons.getWorldIcon('menuBeTasker')
        "
      />
    </div>
    <!-- Titolo -->
    <div class="com-anm22-headBar-title display-flex search" @click="logoClick">
      <template v-if="theme !== 'anm22' || $route.path !== '/login'">
        <a
          :style="{
            color: isOffline
              ? '#fff'
              : $store.getters['config/HBTheme'].appNameColor,
          }"
        >
          {{ $store.getters["config/HBTheme"].appName }}
          <span :style="{ color: isOffline ? '#fff' : '#000' }">{{
            $store.state.headbar.pageTitle !== "" ? "&nbsp;|&nbsp;" : ""
          }}</span>
        </a>
        <div
          :style="{ color: isOffline ? '#fff' : '#000' }"
          v-if="$store.state.headbar.pageTitle !== ''"
        >
          {{ $store.state.headbar.pageTitle }}
        </div>
      </template>
      <div v-else>ANM22 Login</div>
    </div>
    <!-- USER LOGGED RESERVED -->
    <!-- SearchBar -->
    <template v-if="userLogged">
      <div
        v-show="!showMsg"
        :class="[
          'com-anm22-headBar-searchBar',
          showSearchbar ? 'showMobile' : '',
        ]"
        id="com-anm22-headBar-searchBar"
      >
        <input
          v-show="useSearchBar"
          ref="searchBar"
          type="search"
          id="com-anm22-headBar-searchBar-input"
          autocomplete="off"
          :class="[isOffline ? 'inverted' : '']"
          :style="{
            backgroundImage:
              'url(' + $anm22.icons.getWorldIcon('searchLeft') + ')',
          }"
          @focus="searchBarFocus"
          @input="startSearch"
        />
        <div id="com-anm22-headBar-searchBar-hint" v-show="showHints">
          <vue-simple-spinner
            v-if="searchLoading"
            size="small"
          ></vue-simple-spinner>
          <template v-else-if="hints.length > 0">
            <div
              v-for="(hint, index) in hints"
              :key="'hint-' + index"
              :class="hint.type"
              style="cursor: pointer"
              @click="
                resetSearchBar();
                hint.submitFn();
              "
            >
              <img v-if="hint.img" :src="hint.img" />
              <div>{{ hint.label }}</div>
            </div>
            <div
              v-for="(row, index) in customHintRows"
              :key="'row-' + index"
              :class="'custom-hint-row'"
              style="cursor: pointer"
              @click="
                resetSearchBar();
                goToUrl(row.url);
              "
            >
              <div>{{ row.label }}</div>
            </div>
          </template>
          <div v-else>
            <div>
              <div>
                {{ $anm22.strLang(lang, "No results", "Nessun risultato") }}
              </div>
            </div>
          </div>
        </div>
        <img
          class="com-anm22-headBar-searchBar-mobile-close-btn"
          :src="
            $anm22.icons.getWorldIcon(isOffline ? 'deleteWhite' : 'deleteBlack')
          "
          @click="resetSearchBar"
        />
      </div>
      <div
        v-show="useSearchBar"
        class="com-anm22-headBar-searchBar-mobile-btn"
        @click="openSearchBar"
      >
        <img
          :src="
            $anm22.icons.getWorldIcon(isOffline ? 'searchLeft' : 'searchLeft')
          "
        />
      </div>
    </template>
    <div v-show="showMsg" id="com-anm22-headBar-searchBar-msg-box">
      <div id="com-anm22-headBar-searchBar-msg" :class="msgClass">
        <div class="wg-row" style="margin-right: 5px">{{ msg }}</div>
        <img
          :src="$anm22.icons.getWorldIcon('deleteBlack')"
          class="close"
          @click="closeMessage"
        />
      </div>
    </div>
    <!-- Tasti funzione -->
    <template v-if="userLogged">
      <div
        v-for="(btn, index) in customButtons"
        :key="'custom-btn-' + index"
        class="display-flex headbar-custom-btn"
        :title="btn.title"
        @click="btn.clickFn"
      >
        <img
          :src="isOffline ? btn.offlineImg : btn.img"
          :style="btn.style || { height: '50px', width: '50px' }"
          :class="btn.class ? btn.class : null"
          :id="btn.id ? btn.id : null"
        />
      </div>
      <!-- Menu utente -->
      <audio ref="notificationSound" preload="auto">
        <source
          src="https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg"
          type="audio/ogg"
        />
      </audio>
      <!-- Icona Printer Master -->
      <div
        v-if="isPrinterMaster"
        class="com-anm22-headbar-app-logo"
        style="opacity: 0.8"
      >
        <img
          :src="$anm22.icons.getWorldIcon('menuRegisterGrey')"
          :title="$anm22.strLang(lang, 'Printer manager', 'Gestore stampanti')"
          style="width: 59px"
        />
      </div>
      <!-- Icona offline -->
      <div
        v-if="isOffline"
        class="com-anm22-headbar-app-logo"
        style="opacity: 0.8"
      >
        <img
          :src="
            $anm22.icons.getWorldIcon(
              isOffline ? 'airplaneModeWhite' : 'airplaneMode'
            )
          "
          :title="$anm22.strLang(lang, 'Offline', 'Offline')"
          @click="refresh"
          style="width: 40px; cursor: pointer"
        />
      </div>
      <div
        v-else-if="isSyncing"
        class="com-anm22-headbar-app-logo"
        style="opacity: 0.8"
      >
        <img
          :src="$anm22.icons.getWorldIcon('sync')"
          :title="$anm22.strLang(lang, 'Synching', 'Sincronizzazione')"
          style="width: 40px"
        />
      </div>
      <div
        v-else-if="isNotSynchronized()"
        class="com-anm22-headbar-app-logo"
        style="opacity: 0.8"
      >
        <img
          :src="$anm22.icons.getWorldIcon('offline')"
          :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
          @click="runSync()"
          style="width: 40px; cursor: pointer"
        />
      </div>
      <div
        v-if="$store.getters['config/HBTheme'].anm22AppsButton !== false"
        id="anm22_template_anm22it_2014_headBar_user"
        class="anm22_template_anm22it_2014_headBar_user"
      >
        <a
          :href="
            enviromentMode === 'production'
              ? 'https://www.anm22.it/app/world/'
              : frontDomain + '/app/world/'
          "
        >
          <img
            :src="$anm22.icons.getWorldIcon('apps')"
            class="anm22_template_anm22it_2014_headBar_app_img"
          />
        </a>
      </div>
      <div
        v-if="work && work.idWorldWork"
        class="anm22_template_anm22it_2014_headBar_work_img"
        @click="clickUserMenu"
      >
        <world-object-icon
          :type="'work'"
          :obj="work"
          :isImg="true"
          :defaultImg="'workDefault'"
          :square="true"
        >
        </world-object-icon>
      </div>
      <div
        class="anm22_template_anm22it_2014_headBar_user_img"
        style="cursor: pointer; min-width: 39px; text-align: center"
      >
        <world-object-icon
          :type="'user'"
          :obj="user"
          :isImg="true"
          :clickFn="clickUserMenu"
        >
        </world-object-icon>
      </div>
      <img
        id="anm22-headbar-notifications-running-badge"
        :src="$anm22.icons.getWorldIcon('sprint')"
        v-show="runningTask"
      />
      <div
        id="anm22-headbar-notifications-num"
        style="display: block"
        v-if="!userMenuOpen && unread > 0"
      >
        {{ unread }}
      </div>
      <div id="anm22-world-menu-userMenu" v-show="userMenuOpen">
        <div
          id="headbar-notification-running-task"
          v-if="runningTask"
          @click="openRunningTask()"
        >
          <img :src="$anm22.icons.getWorldIcon('sprint')" class="sprint-icon" />
          <div class="running-task-title">
            {{ $anm22.strLang(lang, "Running task", "Turno in corso") }}
          </div>
          <div class="project-name" :title="runningTask.pn">
            {{ runningTask.pn }}
          </div>
          <div class="start-time">
            <div class="time-label">
              {{ $anm22.strLang(lang, "Start", "Inizio") }}:
            </div>
            {{ runningTaskStartTime }}
          </div>
        </div>
        <div
          id="anm22-world-menu-userMenu-sub"
          :class="runningTask ? 'running-task' : ''"
        >
          <div
            style="
              text-align: center;
              padding: 3px;
              font-size: 16px;
              font-weight: bold;
            "
          >
            {{ $anm22.strLang(lang, "Notifications", "Notifiche") }}
          </div>
          <div
            id="headbarNotificationsBox"
            class="com-anm22-app-scrolling-panel notification-container"
          >
            <div
              v-for="(notification, index) in notifications"
              :key="'not-' + index"
              class="notification-div"
            >
              <a :href="notification.url">
                <img
                  :src="getNotificationImg(notification)"
                  class="notification-img"
                />
                <div class="notification-data" style="height: 100%">
                  <div class="notification-text">
                    {{ notification.text }}
                  </div>
                  <div class="notification-time">
                    {{ getNotificationTimeLabel(notification.timestamp) }}
                  </div>
                </div>
              </a>
            </div>
            <!-- Forse: carica altre notifiche / vai alla pagina di con tutte le notifiche -->
            <div
              v-if="!isOffline && !noMoreNotifications"
              class="wg-row"
              style="
                align-items: center;
                justify-content: center;
                margin-top: 5px;
              "
            >
              <input
                type="button"
                class="small"
                :value="$anm22.strLang(lang, 'Load more', 'Carica altre')"
                @click="loadPreviousNotifications"
              />
            </div>
          </div>
        </div>
        <a :href="profileUrl">
          <img
            :src="$anm22.icons.getWorldIcon('person')"
            class="anm22_template_anm22it_2014_headBar_user_menu_img profile"
          />
        </a>
        <div
          v-if="work && work.idWorldWork"
          class="anm22_template_anm22it_2014_headBar_user_menu_img selected-work"
          @click="changeWorkFn"
        >
          <world-object-icon
            :type="'work'"
            :obj="work"
            :isImg="true"
            :defaultImg="'workDefault'"
            :square="true"
          >
          </world-object-icon>
        </div>
        <img
          v-else
          :src="$anm22.icons.getWorldIcon('workMaterial')"
          class="anm22_template_anm22it_2014_headBar_user_menu_img select-work"
          style="cursor: pointer"
          @click="changeWorkFn"
        />
        <img
          :src="$anm22.icons.getWorldIcon('menuLogin')"
          class="anm22_template_anm22it_2014_headBar_user_menu_img logout"
          style="cursor: pointer"
          @click="logout"
        />
      </div>
      <div id="anm22_template_anm22it_clear"></div>
    </template>
    <template v-else-if="publicCustomButtons">
      <div
        v-for="(btn, index) in publicCustomButtons"
        :key="'custom-btn-' + index"
        class="display-flex headbar-custom-btn custom-btn-public"
        :title="btn.title"
        @click="btn.clickFn"
      >
        <img
          :src="isOffline ? btn.offlineImg : btn.img"
          :style="btn.style || { height: '50px', width: '50px' }"
          :class="btn.class ? btn.class : null"
          :id="btn.id ? btn.id : null"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    // Default function for research
    hintFn: {
      type: Function,
      default: () => {},
    },
    customHintRows: {
      type: Array,
      default: () => [],
    },
    customProfileUrl: {
      type: String,
      default: () => null,
    },
    theme: {
      type: String,
      default: () => "anm22",
    },
    changeWorkFn: {
      type: Function,
      default: () => {
        let url =
          process.env.NODE_ENV === "production"
            ? "https://www.anm22.it/app/work/selectWork?cbSucc=" +
              encodeURIComponent(location.href)
            : process.env.VUE_APP_FRONT_DOMAIN +
              "/app/work/selectWork?cbSucc=" +
              encodeURIComponent(location.href);
        location.href = url;
      },
    },
  },
  data() {
    return {
      /* Menu Utente */
      userMenuOpen: false,
      /* Notifications to read */
      unread: 0,
      lastUpdate: 0,
      audioEnabled: false,
      noMoreNotifications: false,
      /* Message */
      showMsg: false,
      msg: "",
      msgClass: "",
      notificationInterval: null,
      /* Search */
      showSearchbar: false,
      showHints: false,
      searchLoading: false,
      hints: [],
      customSearchFunction: null,
      searchedString: "",
      isPrinterMaster: false,
      frontDomain: process.env.VUE_APP_FRONT_DOMAIN || "https://www.anm22.it",
      enviromentMode: process.env.NODE_ENV,
    };
  },
  computed: {
    ...mapState({
      userLogged: (state) => state.auth.userLogged,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      backHref: (state) => state.headbar.backHref,
      useSearchBar: (state) => state.headbar.searchBar,
      isOffline: (state) => state.offline.isOffline,
      isSyncing: (state) => state.offline.isSyncing,
      windowWidth: (state) => state.windowWidth,
      runningTask: (state) => state.headbar.runningTask,
      workSelected: (state) => state.workSelected,
    }),
    notifications() {
      const notifications = this.$store.getters[
        "headbar/getNotifications"
      ].sort((a, b) => b.timestamp - a.timestamp);
      this.unread = notifications.filter((n) => n.read == 0).length;
      return notifications;
    },
    customButtons() {
      if (this.windowWidth > 768) {
        return this.$store.getters["headbar/customButtons"];
      } else {
        return this.$store.getters["headbar/customButtons"].filter(
          (cb) => !cb.mobileHide
        );
      }
    },
    publicCustomButtons() {
      if (this.windowWidth > 768) {
        return this.$store.getters["headbar/customButtons"].filter(
          (cb) =>
            typeof cb.visibility !== undefined && cb.visibility === "public"
        );
      } else {
        return this.$store.getters["headbar/customButtons"].filter(
          (cb) =>
            typeof cb.visibility !== undefined &&
            cb.visibility === "public" &&
            !cb.mobileHide
        );
      }
    },
    runningTaskStartTime() {
      if (this.runningTask) {
        if (Date.now() - this.runningTask.st * 1000 < 86400000) {
          return this.$moment.unix(this.runningTask.st).format("HH:mm");
        } else {
          return this.$moment.unix(this.runningTask.st).format("YYYY-MM-DD");
        }
      }
    },
    profileUrl() {
      if (this.customProfileUrl) {
        return this.customProfileUrl;
      } else if (this.theme == "spiagge") {
        return "https://www.spiagge.it/impostazioni/";
      } else {
        return this.enviromentMode === "production"
          ? "https://www.anm22.it/app/world/profile"
          : this.frontDomain + "/app/world/profile";
      }
    },
    work() {
      return this.workSelected !== "my" &&
        this.$store.getters["works/get"](this.workSelected)
        ? this.$store.getters["works/get"](this.workSelected)
        : {};
    },
  },
  methods: {
    isNotSynchronized() {
      return this.$store.getters["offline/isNotSynchronized"];
    },
    refresh() {
      window.location.reload();
    },
    runSync() {
      this.$store.dispatch("offline/sync", {
        _vue: this,
        blocking: true,
        callback: async (data) => {
          if (this.$route.name === "projectDash" && this.$route.params.id) {
            const update = data.success.find(
              (d) => d.requestData.obj.idWorldProject === this.$route.params.id
            );
            if (update) {
              this.$router.replace(
                "/project/" + update.responseData.idWorldProject
              );
            }
          }
        },
      });
    },
    logoClick() {
      if (this.$route.path === "/login") {
        window.location.href = "https://www.anm22.it/app/world/";
      } else if (!this.userLogged) {
        window.location.href =
          process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL;
      } else {
        this.$router.push(this.$store.state.config.indexHref);
      }
    },
    clickUserMenu() {
      const ts = this.$moment().unix();
      // this.userMenuOpen ? (this.unread = 0) : "";
      if (!this.userMenuOpen) {
        this.unread = 0;
        this.$http
          .post(
            "notifications/read",
            {
              ts,
            },
            {
              withCredentials: true,
            }
          )
          .finally(() => {
            this.$store.dispatch("headbar/setRead", ts);
          });

        // Clear notification badge
        if ("setAppBadge" in navigator && "clearAppBadge" in navigator) {
          navigator.clearAppBadge().catch((error) => {
            console.log("Clear notification badge error");
          });
        }
      }

      // Aggiorno il badge delle attività in corso
      this.updateRunningTaskBadge();

      this.userMenuOpen = !this.userMenuOpen;
    },
    logout() {
      this.clickUserMenu();
      this.$router.push("/logout");
    },
    resetSearchBar() {
      this.showHints = false;
      this.hints = [];
      this.showSearchbar = false;
      this.$refs["searchBar"].value = "";
    },
    searchBarFocus(ev) {
      if (this.$refs["searchBar"].value !== "") {
        this.showHints = true;
      }
    },
    startSearch(ev) {
      this.showHints = true;
      this.hints = [];
      this.searchLoading = true;
      this.loadHints(ev.target.value);
    },
    loadHints: _.debounce(function (string) {
      if (string !== "") {
        this.searchedString = string;
        this.hints = this.customSearchFunction
          ? this.customSearchFunction(string)
          : this.hintFn(string);
      } else {
        this.showHints = false;
      }
      this.searchLoading = false;
    }, 1000),
    goToUrl(url) {
      window.location.href =
        url + "?q=" + encodeURIComponent(this.searchedString);
    },
    openSearchBar() {
      this.showSearchbar = true;
      this.$nextTick(() => {
        this.$refs["searchBar"].focus();
      });
    },
    loadNotifications(limit) {
      this.$http
        .get("notifications/", {
          params: {
            timestamp: this.lastUpdate,
            limit: limit,
          },
        })
        .then((response) => {
          this.$store.commit("offline/setOnlineMode");
          this.lastUpdate = this.$moment().unix();
          if (response.data.notifications.length > 0) {
            this.$store.dispatch(
              "headbar/updateNotifications",
              response.data.notifications
            );
            const notificationNumber = response.data.notifications.filter(
              (n) => n.read == 0
            ).length;
            if (notificationNumber > 0) {
              // Badge notifiche browser
              if ("setAppBadge" in navigator && "clearAppBadge" in navigator) {
                navigator.setAppBadge(notificationNumber).catch((error) => {
                  console.log("Notification badge error");
                });
              }

              if (this.audioEnabled) {
                const sound = this.$refs["notificationSound"];
                sound
                  .play()
                  .then(() => {})
                  .catch((error) => {
                    console.log(error);
                  });
                setTimeout(() => {
                  sound.pause();
                  sound.currentTime = 0;
                }, 1000);
              }
            }
          }
        })
        .catch((error) => {});
    },
    loadPreviousNotifications() {
      const ts = this.notifications
        ? this.notifications[this.notifications.length - 1].timestamp
        : 0;
      this.$http
        .get("notifications/load", {
          params: {
            timestamp: ts,
          },
        })
        .then((response) => {
          if (response.data.notifications.length > 0) {
            this.$store.dispatch(
              "headbar/updateNotifications",
              response.data.notifications
            );
            if (response.data.notifications.length < 10) {
              this.noMoreNotifications = true;
            }
          } else {
            this.noMoreNotifications = true;
          }
        });
    },
    getNotificationImg(notification) {
      if (notification.img !== "") {
        return notification.img;
      } else {
        switch (notification.app) {
          case 2:
            return this.$anm22.icons.getWorldIcon("workIcon");
          case 3:
            return this.$anm22.icons.getWorldIcon("calendarIcon");
          case 4:
            return this.$anm22.icons.getWorldIcon("contactsIcon");
          case 6:
            return this.$anm22.icons.getWorldIcon("yourbeachIcon");
          case 7:
            return this.$anm22.icons.getWorldIcon("foodIcon");
          case 8:
            return this.$anm22.icons.getWorldIcon("taskIcon");
          case 9:
            return this.$anm22.icons.getWorldIcon("payIcon");
          case 10:
            return this.$anm22.icons.getWorldIcon("payShopIcon");
          default:
            return this.$anm22.icons.getWorldIcon("holoApps");
        }
      }
    },
    showMessage(msgObj) {
      if (msgObj.detail) {
        msgObj = msgObj.detail;
      }
      if (msgObj.type) {
        this.msgClass = msgObj.type;
      } else {
        this.msgClass = "neutral";
      }
      this.msg = msgObj.text;
      this.showMsg = true;
      setTimeout(this.closeMessage, 5000);
    },
    // Espandibile in futuro con nuove configurazioni
    searchConfig(config) {
      if (!config) {
        this.customSearchFunction = null;
      } else {
        this.customSearchFunction = config.hintFn || null;
      }
    },
    startListeningDocumentClick(e) {
      let el = this.$refs["searchBar"];
      let target = e.target;
      if (el && el !== target && !el.contains(target)) {
        this.showHints = false;
      }
    },
    enableAudioListener(e) {
      if (!this.audioEnabled) {
        this.audioEnabled = true;
        document.removeEventListener("click", this.enableAudioListener);
      }
    },
    closeMessage() {
      this.showMsg = false;
      this.msg = "";
      this.msgClass = "";
    },
    getNotificationTimeLabel(ts) {
      let label = "";
      const nMoment = this.$moment.unix(ts);
      if (!this.$moment().isSame(nMoment, "day")) {
        label += nMoment.format("ll") + " ";
      }
      label += nMoment.format("HH:mm");
      return label;
    },
    updateRunningTaskBadge() {
      this.$store.commit(
        "headbar/runningTask",
        this.$anm22.getCookie("tk_r_t")
          ? JSON.parse(this.$anm22.getCookie("tk_r_t"))
          : null
      );
    },
    openRunningTask() {
      window.open(
        "https://tasks.anm22.it/project/" + this.runningTask.p + "?page=events",
        "_blank"
      );
    },
  },
  mounted() {
    window.addEventListener(
      "com_anm22_wg_headbar_search_showMessage",
      this.showMessage
    );
    this.$anm22.eventBus.$on("world-headbar-show-message", this.showMessage);
    this.$anm22.eventBus.$on("world-headbar-search-config", this.searchConfig);
    this.$anm22.eventBus.$on(
      "world-headbar-is-printer-master",
      (isPrinterMaster) => {
        this.isPrinterMaster = isPrinterMaster;
      }
    );
    document.addEventListener("click", this.enableAudioListener);
  },
  beforeDestroy() {
    window.removeEventListener(
      "com_anm22_wg_headbar_search_showMessage",
      this.showMessage
    );
    this.$anm22.eventBus.$off("world-headbar-show-message");
    this.$anm22.eventBus.$off("world-headbar-search-config");
    this.$anm22.eventBus.$off("world-headbar-is-printer-master");
    clearInterval(this.notificationInterval);
  },
  created() {
    this.$store.commit(
      "headbar/runningTask",
      this.$anm22.getCookie("tk_r_t")
        ? JSON.parse(this.$anm22.getCookie("tk_r_t"))
        : null
    );
    let w = this.$anm22.getCookie("anm22_work");
    if (w !== "") {
      this.$store.dispatch("setWorkSelected", w === "my" ? w : Number(w));
    }
  },
  watch: {
    userLogged(val, old) {
      if (val === true) {
        this.loadNotifications(10);
        this.unread = 0;
        /* Interval to load notifications */
        this.notificationInterval = setInterval(() => {
          //In questo modo non si perde il contesto della funzione
          this.loadNotifications(0);
          this.updateRunningTaskBadge();
        }, 30000);
      }
    },
    showHints(val, old) {
      if (val) {
        document.addEventListener("click", this.startListeningDocumentClick);
      } else {
        document.removeEventListener("click", this.startListeningDocumentClick);
      }
    },
  },
  components: {
    "vue-simple-spinner": Spinner,
  },
};
</script>

<style lang="scss" scoped>
#anm22_template_anm22it_2014_headBar.inverted {
  background-color: #666;
  border-bottom: 1px solid #555;
}

.anm22_template_anm22it_2014_headBar_holo_img_square {
  cursor: pointer;
}
#com-anm22-headBar-searchBar-input {
  -webkit-appearance: none;
  &.inverted {
    background-color: #fff;
  }
}
#com-anm22-headBar-searchBar-hint {
  display: block;
}
#com-anm22-headBar-searchBar-msg-box {
  display: block;
}
#com-anm22-headBar-searchBar-msg {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  padding: 10px;
}

#com-anm22-headBar-searchBar-msg .close {
  position: static;
  margin-left: auto;
}

#anm22-headbar-notifications-num {
  position: absolute;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background: #f00;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  text-align: center;
  line-height: 1;
  box-sizing: border-box;
  padding-top: 2px;
  bottom: 8px;
  right: 8px;
}

#anm22-world-menu-userMenu {
  border: 1px solid #ddd;
  width: 53px;
  position: absolute;
  top: 63px;
  right: 4px;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0 3px 15px hsla(0, 0%, 0%, 0.1);
  & > .anm22_template_anm22it_2014_headBar_user_menu_img:last-child {
    border-bottom: 0;
  }
}

.headbar-custom-btn {
  height: 59px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.5;

  &.custom-btn-public {
    padding-right: 10px;
  }
}

#anm22-headbar-notifications-running-badge {
  position: absolute;
  background: #ddd;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  text-align: center;
  line-height: 1;
  box-sizing: border-box;
  padding: 1px 2px;
  bottom: 8px;
  right: 8px;
}
#headbar-notification-running-task {
  position: absolute;
  width: 75%;
  width: calc(100% - 86px);
  width: calc(100vw - 86px);
  max-width: 432px;
  min-width: 200px;
  height: 80px;
  background-color: #eee;
  right: 58px;
  top: -1px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 5px 0;
  box-shadow: 0 3px 15px hsla(0, 0%, 0%, 0.1);
  cursor: pointer;

  .sprint-icon {
    position: absolute;
    left: 10px;
    top: 23px;
    width: 30px;
    opacity: 0.6;
  }
  .running-task-title {
    position: absolute;
    left: 50px;
    top: 10px;
    font-size: 10px;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
  }
  .project-name {
    position: absolute;
    left: 50px;
    top: 27px;
    font-size: 14px;
    width: calc(100% - 60px);
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .start-time {
    position: absolute;
    left: 50px;
    top: 46px;
    font-size: 22px;
    .time-label {
      font-size: 10px;
      display: inline-block;
      text-align: bottom;
      margin-right: 5px;
    }
  }
}
</style>
